import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Button,
  Grid,
  IconButton,
  Paper,
  Toolbar,
  Typography
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Form, Field } from "react-final-form";
import { TextField } from "final-form-material-ui";
import { connect } from "react-redux";
import { initRegistrationRequest } from "../actions";
import { history } from "../helpers/history";
import { withStyles } from "@material-ui/core/styles";
import MySnackbar from "./MySnackbar";
import MyGridItem from "./MyGridItem";

const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: 600,
    margin: "0 auto"
  },
  link: {
    textDecoration: "none",
    color: "white"
  },
  title: {
    flexGrow: 1
  }
});

const validate = values => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = "Required";
  }
  if (!values.lastName) {
    errors.lastName = "Required";
  }
  if (!values.city) {
    errors.city = "Required";
  }
  if (!values.state) {
    errors.state = "Required";
  }
  if (!values.email) {
    errors.email = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Required";
  }
  if (values.password !== values.confirmPassword) {
    errors.password = "Password and confirmation don't match";
  }
  return errors;
};

const initialValues = {};

// function contains(theArray, obj) {
//   var i = theArray.length;
//   while (i--) {
//     if (theArray[i] === obj) {
//       return true;
//     }
//   }
//   return false;
// }

class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = { openDialog: false };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.message) {
      this.setState({
        openDialog: true
      });
    }
  }

  handleSubmit = values => {
    this.props.initRegistrationRequest(values);
  };

  handleCloseDialog = () => {
    // console.log("Closing the dialog");
    // this.setState({ dialogOpen: false, submitted: false });
    if (this.state.registered) {
      history.push("/");
    }
  };

  render() {
    const classes = this.props.classes;
    console.log(
      "message is " +
        this.props.message +
        " and the dialog is " +
        this.state.openDialog
    );
    return (
      <div className={classes.root}>
        <AppBar title="Home" position="static">
          <Toolbar>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
            >
              <a href="https://www.openempi.org" className={classes.link}>
                <MenuIcon />
              </a>
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              OpenEMPI Downloads
            </Typography>
          </Toolbar>
        </AppBar>
        <Form
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit, form, submitting, pristine }) => (
            <div>
              <form onSubmit={handleSubmit} noValidate>
                <Paper style={{ padding: 16 }}>
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    direction="row"
                    spacing={2}
                  >
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        required
                        name="firstName"
                        component={TextField}
                        type="text"
                        label="First Name"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        required
                        name="lastName"
                        component={TextField}
                        type="text"
                        label="Last Name"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        required
                        name="city"
                        component={TextField}
                        type="text"
                        label="City"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        required
                        name="state"
                        component={TextField}
                        type="text"
                        label="State"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        required
                        name="country"
                        component={TextField}
                        type="text"
                        label="Country"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        name="postalCode"
                        component={TextField}
                        type="text"
                        label="Zip Code"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={10}>
                      <Field
                        fullWidth
                        required
                        name="email"
                        component={TextField}
                        type="email"
                        label="Email"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5} minHeight={96}>
                      <Field
                        fullWidth
                        required
                        name="password"
                        component={TextField}
                        type="password"
                        label="Password"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5} minHeight={96}>
                      <Field
                        fullWidth
                        name="confirmPassword"
                        component={TextField}
                        type="password"
                        label="Confirm Password"
                      />
                    </MyGridItem>
                    <Grid item xs={12}>
                      <Grid container justify="center" spacing={3}>
                        <Grid item>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={submitting}
                          >
                            Submit
                          </Button>
                        </Grid>
                        <Grid item>
                          <Link to="/login">
                            <Button
                              type="submit"
                              variant="contained"
                              color="primary"
                              disabled={submitting}
                            >
                              Cancel
                            </Button>
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </form>
            </div>
          )}
        />
        <MySnackbar message={this.props.message} open={this.state.openDialog} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  console.log(state.registration);
  const { registered, status, errorMessage } = state.registration;
  if (registered) {
    return {
      registered: true,
      message:
        "Please confirm your registration by clicking on the click in the email we sent you."
    };
  } else {
    return { message: errorMessage, status };
  }
}

export default connect(
  mapStateToProps,
  { initRegistrationRequest }
)(withStyles(styles)(RegistrationForm));
